export const recommendSchema = [
  {
    title: '',
    colId: 'organizationId',
    isI18n: true,
  },
  {
    title: 'companyAnalysis.peerAnalysis.COMPANY_NAME',
    colId: 'organizationName',
    isI18n: true,
  },
  {
    title: 'companyAnalysis.peerAnalysis.INDUSTRY_TABLE',
    colId: 'vsicName',
    isI18n: true,
  },
  {
    title: 'companyAnalysis.peerAnalysis.REVENUE',
    colId: 'iS3',
    isI18n: true,
    thStyle: { justifyContent: 'flex-end' },
    tdStyle: { textAlign: 'right' },
  },
  {
    title: 'companyAnalysis.peerAnalysis.TOTAL_ASSETS',
    colId: 'bS64',
    isI18n: true,
    thStyle: { justifyContent: 'flex-end' },
    tdStyle: { textAlign: 'right' },
  },
  {
    title: 'companyAnalysis.peerAnalysis.YEARS_OF_OPERATION',
    colId: 'age',
    isI18n: true,
    thStyle: { justifyContent: 'flex-end' },
    tdStyle: { textAlign: 'right' },
  },
  {
    title: 'companyAnalysis.peerAnalysis.CREDIT_RISK_SCORE',
    colId: 'creditRiskScore',
    isI18n: true,
    thStyle: { textAlign: 'center' },
    tdStyle: { textAlign: 'center' },
  },
  {
    title: 'companyAnalysis.peerAnalysis.PERFORMANCE_SCORE',
    colId: 'performanceScore',
    isI18n: true,
    thStyle: { textAlign: 'center' },
    tdStyle: { textAlign: 'center' },
  },
]

export const FA_COLORS = [
  { color: '#F49966' },
  { color: '#00A8B5' },
  { color: '#74B49A' },
  { color: '#FF596A' },
]

export const SCORE_COLORS = [
  { color: '#F49966' },
  { color: '#00A8B5' },
  { color: '#74B49A' },
  { color: '#FF596A' },
]

export const MAX_SELECTED_COMPANY = 30
